const countRoast = (product: any): number => {
  // Only match tags like 'Roast 4' - substring matching would also catch
  // 'Taste ... Roasted-Hazelnut' and 'info roast' tags
  const roastTag: string = product.tags.find((tag: string) => /^roast\s+\d/i.test(tag));

  return roastTag ? parseInt(roastTag.split(/\s+/)[1], 10) : 0;
};

export default countRoast;
